var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 0.166748C4.39996 0.166748 0.666626 3.90008 0.666626 8.50008C0.666626 13.1001 4.39996 16.8334 8.99996 16.8334C13.6 16.8334 17.3333 13.1001 17.3333 8.50008C17.3333 3.90008 13.6 0.166748 8.99996 0.166748ZM9.83329 14.3334H8.16663V12.6667H9.83329V14.3334ZM11.5583 7.87508L10.8083 8.64175C10.2083 9.25008 9.83329 9.75008 9.83329 11.0001H8.16663V10.5834C8.16663 9.66675 8.54163 8.83342 9.14163 8.22508L10.175 7.17508C10.4833 6.87508 10.6666 6.45842 10.6666 6.00008C10.6666 5.08342 9.91663 4.33342 8.99996 4.33342C8.08329 4.33342 7.33329 5.08342 7.33329 6.00008H5.66663C5.66663 4.15841 7.15829 2.66675 8.99996 2.66675C10.8416 2.66675 12.3333 4.15841 12.3333 6.00008C12.3333 6.73342 12.0333 7.40008 11.5583 7.87508Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.18b7967a.svg";
export { ForwardRef as ReactComponent };